import { UrlUtils } from '@space-shell/common/utils/url'

import type { ExternalLinkFormFields } from '../externalLinkModal'

export const NAME_MAX_SIZE = 24

export const formFields: ExternalLinkFormFields = {
  name: {
    name: 'name',
    value: ''
  },
  icon: {
    name: 'icon',
    value: ''
  },
  url: {
    name: 'url',
    value: ''
  }
}

const isEmpty = (value: string) => !value.trim().length

export const formFieldsValidator: Record<
  keyof ExternalLinkFormFields,
  Record<'isValid', (value: string) => boolean>
> = {
  icon: {
    isValid: () => true
  },
  name: {
    isValid: (value: string) => !isEmpty(value) && value.trim().length <= NAME_MAX_SIZE
  },
  url: {
    isValid: (value: string) => !isEmpty(value) && UrlUtils.isValid(value)
  }
}
